// extracted by mini-css-extract-plugin
module.exports = {"message":"_ce0bbd6"};